import React from 'react';
import { Link } from 'react-router-dom';
import './Footer1.css'

const Footer1 = () => {
  return (
    <div className='main-footer'>
        <div className='container'>
            <div className='row'>
               {/* column1 */}
               <div className='col'>
                <p>DataDisca</p>
                <ul className='list-unstyled'>
                    <li>Contact us : science@datadisca.com</li>
                    {/* <li>Australia</li> */}
                    <li>Ground floor, 470 St Kilda Rd, Melbourne VIC 3004, Australia</li>                    
                </ul>
               </div>
               {/* column2 - Navbar Links */}
               <div className='col'>
                <p>Quick Links</p>
                <ul className='list-unstyled'>
                    <li>
                        <Link to='/' className='nav-links'>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to='/technology' className='nav-links'>
                            Technology
                        </Link>
                    </li>
                    <li>
                        <Link to='/contact' className='nav-links'>
                            Contact
                        </Link>
                    </li>
                    {/* <li>
                        <Link to='/sign-up' className='nav-links'>
                            Sign Up
                        </Link>
                    </li> */}
                </ul>
               </div>
               {/* column3 - Technologies */}
               <div className='col'>
                <p>Our Technologies</p>
                <ul className='list-unstyled'>
                    <li>Artificial Intelligence</li>
                    <li>Machine Learning</li>
                    <li>Data Science</li>
                    <li>Cloud Computing</li>
                    {/* <li>Blockchain Technology</li>
                    <li>Cybersecurity</li> */}
                    <li>Data Engineering</li>
                    <li>Data Analytics</li>
                </ul>
               </div>
            </div>
        </div>
    </div>
  );
}

export default Footer1;
